import { DefaultService, PlayOutput } from '../generated-api';

const PAGE_SIZE = 200;
const CACHE_MS = 5 * 60 * 1000;

let cached: { at: number; promise: Promise<PlayOutput[]> } | null = null;

/** Every play (all pages, newest first), shared for five minutes across pages. */
export const fetchAllPlays = (): Promise<PlayOutput[]> => {
  if (cached && Date.now() - cached.at < CACHE_MS) return cached.promise;
  const promise = (async () => {
    const all: PlayOutput[] = [];
    for (let offset = 0; ; offset += PAGE_SIZE) {
      const page = await DefaultService.getPlaysPlaysGet({ limit: PAGE_SIZE, offset, sort: 'newest' });
      all.push(...page);
      if (page.length < PAGE_SIZE) return all;
    }
  })();
  cached = { at: Date.now(), promise };
  promise.catch(() => { cached = null; });
  return promise;
};

/** Test hook: forget the cached plays. */
export const resetAllPlaysCache = () => { cached = null; };
